var React = require('react');

function GreySeparator (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1-separator {\n        fill: #c4c4c4;\n      }\n    ")),React.createElement("rect",{"id":"Rectangle_139","data-name":"Rectangle 139","className":"cls-1-separator","width":"144","height":"3","key":1})]);
}

GreySeparator.defaultProps = {"width":"144","height":"3","viewBox":"0 0 144 3"};

module.exports = GreySeparator;

GreySeparator.default = GreySeparator;
